export const AxiosErrorCodes = {
  aborted: 'ECONNABORTED',
};
